import { descargarReporteExcel } from "../../../../ProduccionV2/helpers/descargarReporteExcel";

// Excel de un cierre ya cerrado: resumen por producto y detalle por pallet
export const descargarCierreInventarioExcel = (cierre) =>
    descargarReporteExcel(
        "prod_bodega_reportes/cierre_inventario_excel",
        { cierre_id: cierre.id },
        `cierre_inventario_${cierre.numero}.xlsx`,
    );
